import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import VodafoneBadge from '../components/VodafoneBadge';

const IconPause = ({ size = 16 }) => (<svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>);
const nf = (n) => (n == null ? '—' : Number(n).toLocaleString('it-IT'));

function Bar({ c, l, p, v }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 2px' }}>
      <span style={{ width: 12, height: 12, borderRadius: '50%', background: c, flex: '0 0 auto' }} />
      <span style={{ flex: 1, fontSize: 13 }}>{l}</span>
      <div style={{ flex: '0 0 70px', height: 6, background: 'var(--line)', borderRadius: 4, overflow: 'hidden' }}>
        <div style={{ width: `${p}%`, height: '100%', background: c }} />
      </div>
      <span style={{ flex: '0 0 54px', textAlign: 'right', fontSize: 13, fontWeight: 700 }}>{nf(v)} · {p}%</span>
    </div>
  );
}

export default function VfPage() {
  const [d, setD] = useState(null);
  const load = useCallback(() => { axios.get(`${API}/gea/dashboard`).then((r) => setD(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); const t = setInterval(load, 12000); return () => clearInterval(t); }, [load]);

  if (!d) return <div className="m-empty">Caricamento…</div>;

  const attivo = d.agente_attivo;
  const job = d.job;
  const totEsiti = (d.vodafone || 0) + (d.negativi || 0) + (d.errori || 0);

  return (
    <>
      <div className={`m-verdict ${attivo ? '' : 'warn'}`}>
        <span className="vi">{attivo ? <VodafoneBadge size={16} /> : <IconPause size={16} />}</span>
        <div>
          <div className="vt">{d.abilitata === false ? 'Verifica disabilitata' : attivo ? (job ? 'AI in verifica' : 'AI in attesa') : 'AI VF fermo'}</div>
          <div className="vs">{job ? `${nf(job.completed)}/${nf(job.total)} · ${nf(job.vodafone)} Vodafone` : `${nf(d.eligibili)} da verificare`}</div>
        </div>
      </div>

      <div className="m-secrow"><h2>Vodafone</h2></div>
      <div className="m-chips">
        <div className="m-chip"><div className="cn">{nf(d.non_tim)}</div><div className="cl">NON TIM fissi</div></div>
        <div className="m-chip k-tim"><div className="cn">{nf(d.verificati)}</div><div className="cl">Verificati</div></div>
        <div className="m-chip k-non"><div className="cn">{nf(d.eligibili)}</div><div className="cl">Da fare</div></div>
        <div className="m-chip k-cop"><div className="cn">{nf(d.vodafone)}</div><div className="cl">Vodafone</div></div>
      </div>

      <div className="m-secrow"><h2>Scoperte</h2></div>
      <div className="m-chips">
        <div className="m-chip k-lead"><div className="cn">{nf(d.nuovi)}</div><div className="cl">Nuovi Vodafone</div></div>
        <div className="m-chip"><div className="cn">{nf(d.confermati)}</div><div className="cl">Confermati</div></div>
      </div>

      <div className="m-secrow"><h2>Esiti</h2></div>
      {totEsiti === 0 ? (
        <div className="m-empty">Nessuna verifica ancora.</div>
      ) : (
        <>
          <Bar c="#e60000" l="Vodafone" p={Math.round((100 * d.vodafone) / totEsiti)} v={d.vodafone} />
          <Bar c="#64748b" l="Non Vodafone" p={Math.round((100 * d.negativi) / totEsiti)} v={d.negativi} />
          <Bar c="#f59e0b" l="Errori" p={Math.round((100 * d.errori) / totEsiti)} v={d.errori} />
        </>
      )}
    </>
  );
}
